import { CheckUtils, logger, UpdatedAllModelVoData, UpdatedModelVoData } from "..";
import { StorageData } from "../storage/storage-data";
var Model = /** @class */ (function () {
    function Model(storage, events, _keyItem) {
        this.storage = storage;
        this.events = events;
        this._keyItem = _keyItem;
        this._model = new Map();
        this._event = {
            LOADED: this._keyItem + ':loaded',
            CLEARED: this._keyItem + ':cleared',
            ADDED_ALL: this._keyItem + ':added-all',
            UPDATED_ALL: this._keyItem + ':updated-all',
            DELETED_ALL: this._keyItem + ':deleted-all',
            ADDED: this._keyItem + ':added',
            UPDATED: this._keyItem + ':updated',
            DELETED: this._keyItem + ':deleted',
        };
        this._error = {
            ADDED: "Error on add item in '" + this._keyItem + "'model. Item is not defined or not added.",
            UPDATED: "Error on update item in '" + this._keyItem + "'model. Item is not defined or not updated.",
            DELETED: "Error on delete item in '" + this._keyItem + "' model. Item is not defined or not deleted.",
        };
    }
    Object.defineProperty(Model.prototype, "event", {
        get: function () {
            return this._event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "error", {
        get: function () {
            return this._error;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "keyItem", {
        set: function (value) {
            this._keyItem = value;
        },
        enumerable: true,
        configurable: true
    });
    Model.prototype.loadEncryptData = function () {
        var _this = this;
        this.storage.load(this._keyItem).then(function (entries) {
            if (!CheckUtils.isEmpty(entries) && typeof entries !== 'string') {
                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                    var entry = entries_1[_i];
                    if (!CheckUtils.isEmpty(entry) && !CheckUtils.areEmpty(entry[0], entry[1]))
                        _this._model.set(entry[0], entry[1]);
                }
            }
            _this.events.publish(_this.event.LOADED);
        });
    };
    Model.prototype.save = function (storageData) {
        storageData.key = this._keyItem;
        storageData.item = this._model;
        return this.storage.saveAs(storageData);
    };
    Model.prototype.clear = function (preventDefault, preventSave) {
        this._model.clear();
        var storageData = new StorageData(this.event.CLEARED, preventDefault);
        storageData.preventSave = preventSave;
        return this.save(storageData);
    };
    Model.prototype.addAll = function (items, preventDefault, preventSave) {
        if (CheckUtils.isEmpty(items))
            return;
        var added = [];
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (this.add(item, true, true))
                added.push(item);
        }
        var storageData = new StorageData(this.event.ADDED_ALL, preventDefault, added);
        storageData.preventSave = preventSave;
        return this.save(storageData);
    };
    Model.prototype.updateAll = function (updatesData, preventDefault, uids) {
        if (CheckUtils.isEmpty(uids)) {
            uids = Array.from(this._model.keys());
            if (CheckUtils.isEmpty(uids))
                return false;
        }
        var updateDatasMap = new Map();
        for (var _i = 0, updatesData_1 = updatesData; _i < updatesData_1.length; _i++) {
            var updateData = updatesData_1[_i];
            updateDatasMap.set(updateData.path, updateData);
        }
        var updated = [];
        for (var _a = 0, uids_1 = uids; _a < uids_1.length; _a++) {
            var uid = uids_1[_a];
            if (this.update(uid, updatesData, true, true))
                updated.push(uid);
        }
        return this.save(new StorageData(this.event.UPDATED_ALL, preventDefault, new UpdatedAllModelVoData(updated, updateDatasMap)));
    };
    Model.prototype.deleteAll = function (uids, preventDefault) {
        if (CheckUtils.isEmpty(uids))
            return;
        var deleted = [];
        for (var _i = 0, uids_2 = uids; _i < uids_2.length; _i++) {
            var uid = uids_2[_i];
            if (this.delete(uid, true, true))
                deleted.push(uid);
        }
        return this.save(new StorageData(this.event.DELETED_ALL, preventDefault, deleted));
    };
    Model.prototype.add = function (item, preventDefault, preventSave) {
        if (CheckUtils.isEmpty(item) || CheckUtils.isEmpty(item.uid) || this._model.set(item.uid, item) == null) {
            logger.warn(this.error.ADDED);
            return false;
        }
        var storage = new StorageData(this.event.ADDED, preventDefault, item);
        storage.preventSave = preventSave;
        return this.save(storage);
    };
    Model.prototype.update = function (uid, updatesData, preventDefault, preventSave) {
        if (CheckUtils.areEmpty(uid, updatesData)) {
            logger.warn(this.error.UPDATED);
            return false;
        }
        var item = this.get(uid);
        if (CheckUtils.isEmpty(item)) {
            logger.warn(this.error.UPDATED);
            return false;
        }
        var updateDatasMap = new Map();
        for (var _i = 0, updatesData_2 = updatesData; _i < updatesData_2.length; _i++) {
            var updateData = updatesData_2[_i];
            item[updateData.path] = updateData.value;
            updateDatasMap.set(updateData.path, updateData);
        }
        var storage = new StorageData(this.event.UPDATED, preventDefault, new UpdatedModelVoData(item.uid, updateDatasMap));
        storage.preventSave = preventSave;
        return this.save(storage);
    };
    Model.prototype.delete = function (uid, preventDefault, preventSave) {
        if (!this.has(uid) || !this._model.delete(uid)) {
            logger.warn(this.error.DELETED);
            return false;
        }
        var storage = new StorageData(this.event.DELETED, preventDefault, uid);
        storage.preventSave = preventSave;
        return this.save(storage);
    };
    Model.prototype.get = function (uid) {
        if (!this.has(uid))
            return null;
        return this._model.get(uid);
    };
    Model.prototype.getAll = function (uids) {
        var items = [];
        if (CheckUtils.isEmpty(uids)) {
            items = Array.from(this._model.values());
        }
        else {
            for (var _i = 0, uids_3 = uids; _i < uids_3.length; _i++) {
                var uid = uids_3[_i];
                var item = this.get(uid);
                if (!CheckUtils.isEmpty(item))
                    items.push(item);
            }
        }
        return items;
    };
    Model.prototype.size = function () {
        return this._model.size;
    };
    Model.prototype.isEmpty = function () {
        return 0 == this._model.size;
    };
    Model.prototype.has = function (uid) {
        return (!CheckUtils.isEmpty(uid) && this._model.has(uid));
    };
    return Model;
}());
export { Model };
//# sourceMappingURL=model.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/models/model.js
// module id = 26
// module chunks = 14